import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/map';
declare var $: any;
declare var jQuery: any;
import { Subject } from 'rxjs/Rx';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

import { ComplianceService } from '../../services/compliance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from '../../helpers/commonFunction';

import { environment } from '../../../environments/environment';
import { CustomValidation } from '../../helpers/customValidation';
import * as _ from 'lodash';
import { TreeModule, TreeComponent, TreeModel, TreeNode, ITreeOptions } from 'angular-tree-component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CategoryMasterService } from 'src/app/services/category-master.service';
import { AlertComponent } from '../alert/alert.component';
import {  ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-lawsn-regulation',
  templateUrl: './lawsn-regulation.component.html',
  styleUrls: ['./lawsn-regulation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LawsnRegulationComponent implements OnInit {
  @ViewChild('tree') treeComponent: TreeComponent;
  private tree: TreeComponent;


  options: ITreeOptions = {
    scrollContainer: <HTMLElement>document.body.parentElement
  };
  

  public environmentSettings: any;
  compliancemenudata: any;
  menulistid: any;
  complianceAddForm: FormGroup;

  FileChangedName: any = new Array();
  FileNameOrignalDisplay: any = new Array();
  updatedDocsFlag: boolean = false;

  filesToUpload1: Array<File>;
  fileUpload: any;
  IsSelectedUpload: any;
  filedata: any = [];
  FileName: any;
  nodes: any = [];
  treedata;
  subnode: boolean;
  subnodevalue: any;
  index: any;
  evaluationMapper: any;
  nodedata: any;
  iframeURL: SafeResourceUrl;
  title: any;
  itemvalue: any;
  name: any;
  editfileurl: any;
  editnodename: any;
  compliancetitle: any;
  nodeid: any;
  addchildren:any;
  childflag:boolean;
  childid:any;


  constructor(private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private categoryMasterService: CategoryMasterService,
    private complianceService: ComplianceService,
    private customValidation: CustomValidation,
    private sanitizer: DomSanitizer,
    private router: Router) {

    this.subnode = false;


  }

  ngOnInit() {

    this.environmentSettings = environment;
    this.editfileurl = null;
    this.getCompliancelist();

    this.complianceAddForm = new FormGroup({
      name: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator
      ]),
     
      file: new FormControl('', )
    });


  }

  ngAfterInit() {
    setTimeout(() => {
        this.tree.treeModel.expandAll();
    }, 0);
    const treeModel: TreeModel = this.treeComponent.treeModel;
    const firstNode: TreeNode = treeModel.getFirstRoot();

    firstNode.setActiveAndVisible();
  }

  ngAfterContentInit() {
    this.getCompliancelist();
  }
  normalizeTreeData(nodes: any[]): any[] {
    return nodes.map(node => {
      return {
        id: node.id,
        name: node.name,
        file: node.file || null,
        data: node, // for your template access
        children: node.children && Array.isArray(node.children)
          ? this.normalizeTreeData(node.children)
          : []
      };
    });
  }
  
  // getCompliancelist() {
  //   this.complianceService.getCompliancemenuList()
  //     .subscribe(data => {
  //       const rawList = data.data[0].MenuList;
  //       this.menulistid = data.data[0]._id;
        
  //       // Normalize the data
  //       this.nodes = this.normalizeTreeData(rawList);
  //       console.log('Final Tree Data:', this.nodes);
  //     });
  // }
  
  getCompliancelist() {
    this.complianceService.getCompliancemenuList().subscribe(data => {
      const rawTree = data.data[0].MenuList;
      this.menulistid = data.data[0]._id;
  
      // Ensure deep children exist
      this.nodes = this.ensureChildrenKey(rawTree);
    });
  }
  
  ensureChildrenKey(nodes: any[]): any[] {
    this.logTreeLevels(this.nodes);

    return nodes.map(node => {
      const children = Array.isArray(node.children) ? this.ensureChildrenKey(node.children) : [];
      return {
        ...node,
        children
      };
    });
  }
  logTreeLevels(nodes: any[], level: number = 0) {
    nodes.forEach(node => {
      console.log(' '.repeat(level * 2) + `- ${node.name || node.title}`);
      if (node.children && node.children.length) {
        this.logTreeLevels(node.children, level + 1);
      }
    });
  }

  attachData(node: any): any {
    const newNode = {
      ...node,
      data: node, // required for the template
      children: node.children?.map(child => this.attachData(child)) || []
    };
    return newNode;
  }
  addNode(evaluationMapper, node, index, modelvalue) {
    this.nodeid = node.path[0];
    
    this.subnode = true;
    this.evaluationMapper = evaluationMapper;
    this.nodedata = node;
    this.index = index;
    this.compliancetitle = 'Add Sub Menu';

    this.complianceAddForm.reset();
    // other logic here..
    // modelNode from dialog data
    if (modelvalue != null) {
      let modelNode = modelvalue;
      if (node.data.children) {
        this.childflag = false;
        node.data.children.push(modelNode);
        node.treeModel.update();
        const someNode = node.treeModel.getNodeById(node.data.id);
        someNode.expand();
        this.childid = someNode.data.id;
        
      } else {
        this.childflag = true;
        node.data.children = [];
        node.data.children.push(modelNode);
        node.treeModel.update();
        const someNode = node.treeModel.getNodeById(node.data.id);
        someNode.expand();
        this.childid = someNode.data.id;
        

        var obj = {children:[]};
        obj.children.push(node.data.children)
        
  
      }


      this.subnode = false;
    }


  };

  deleteNode(evaluationMapper, node, index, modelvalue) {
    this.evaluationMapper = evaluationMapper;
    this.nodedata = node;
    this.index = index;
  }

  delete() {
    let nodeToDelete = this.nodedata.treeModel.getNodeById(this.nodedata.data.id);
    this.removeNode(nodeToDelete);

  }

  editNode(evaluationMapper, node, index, modelvalue, fileurl) {
    this.compliancetitle = 'Edit Menu';
    this.editfileurl = fileurl;
    this.evaluationMapper = evaluationMapper;
    this.nodedata = node;
    this.index = index;
    let nodeToDelete = this.nodedata.treeModel.getNodeById(this.nodedata.data.id);
    this.editnodename = this.nodedata.data.name;
    this.complianceAddForm.controls.name.setValue(this.nodedata.data.name);
    this.complianceAddForm.controls.file.setValue('');


  }

  editdata(model, node) {
    node = this.nodedata;
    node.treeModel.getNodeById(node.data.id)
    node.data.name = model.value.name;
    if (this.FileName) {
      node.data.file = '/complianceDocs/' + this.FileName;
      this.upload();
    }
    node.treeModel.update();
    let inputjson = {
      menudata: this.nodes,
      id: this.menulistid
    }

    this.complianceService.updateCompliance(inputjson).subscribe(data => {
      if (data.status == 0) {
        this.FileName = '';
        $('#complinaceDialog').modal('toggle');
        this.getCompliancelist();
      }
      else {
        this.alert.error(data.message);
      }
    });

  }

  deleteFile(node) {
    node = this.nodedata;
    node.treeModel.getNodeById(node.data.id);
    node.data.file = null;
    node.treeModel.update();
    let inputjson = {
      menudata: this.nodes,
      id: this.menulistid
    }

    this.complianceService.updateCompliance(inputjson).subscribe(data => {
      if (data.status == 0) {
        $('#complinaceDialog').modal('toggle');
        this.getCompliancelist();
      }
      else {
        this.alert.error(data.message);
      }
    });

  }

  removeNode(node: TreeNode) {
    let parentNode = node.realParent
      ? node.realParent
      : node.treeModel.virtualRoot;

    _.remove(parentNode.data.children, function (child) {
      return child === node.data;
    });

    node.treeModel.update();
    let inputjson = {
      menudata: this.nodes,
      id: this.menulistid
    }

    this.complianceService.updateCompliance(inputjson).subscribe(data => {
      if (data.status == 0) {
        this.getCompliancelist();
      }
      else {
        this.alert.error(data.message);
      }
    });
  }


  Add() {

    this.router.navigate(['compliance/addCompliance']);
  }


  showAddPopUp() {
    this.subnode = false;
    this.compliancetitle = 'Add New Menu';
    this.complianceAddForm.reset();
  }


  addCompliance(model) {
    if (this.FileName) {
      model.value.file = '/complianceDocs/' + this.FileName;
    }

    let addCompliancedata = [];
    if (this.subnode) {

      this.addNode(this.evaluationMapper, this.nodedata, this.index, model.value);

      if (this.compliancemenudata) {


        addCompliancedata = this.nodes;

        this.nodes.forEach(element => {
          if(element.id == this.nodeid){
            this.addchildren = element.children;
          }
        })


        this.updatecompliancedata(this.addchildren, this.menulistid);
      }
    }

    else {
      
      model.value.children = [];
      if (this.compliancemenudata) {

        addCompliancedata.push(model.value)
        this.savecompliancedata(addCompliancedata, this.menulistid);

      }

      else {
        addCompliancedata = model.value;
        this.savecompliancedata(addCompliancedata, null);

      }

    }

  }


  savecompliancedata(data, id) {

    if (this.FileName) {
      this.upload();
    }


    let inputjson = {
      menudata: data,
      id: id
    }

    this.complianceService.addCompliance(inputjson).subscribe(data => {
      if (data.status == 0) {
        $('#complinaceDialog').modal('toggle');
        this.FileName = '';
        this.getCompliancelist();

        this.alert.successWithOk(data.message, '/compliance')

      }
      else {
        this.alert.error(data.message);
      }
    });

  }


  updatecompliancedata(data, id) {

    if (this.FileName) {
      this.upload();
    }

    let inputjson = {
      menudata: this.addchildren,
      id: id,
      nodeid: this.nodeid,
      flag : this.childflag,
      childid:this.childid
    }

    this.complianceService.addsubnode(inputjson).subscribe(data => {
      if (data.status == 0) {
        $('#complinaceDialog').modal('toggle');
        this.FileName = '';
        this.getCompliancelist();

        this.alert.successWithOk(data.message, '/compliance')

      }
      else {
        this.alert.error(data.message);
      }
    });

  }




  fileChangeEvent(fileInput: any) {
    this.filesToUpload1 = <Array<File>>fileInput.target.files;

    this.makefilename(this.filesToUpload1);

  }

  makefilename(files) {

    for (var i = 0; i < files.length; i++) {
      var newDate = Date.now();
      this.itemvalue = files[i];
      this.FileName = newDate + '-' + files[i].name.replace('-', '');
    }

  }


  upload() {
    this.makeFileRequest1(environment.goEvaUrl + "compliance/fileUpload/", [], this.filesToUpload1).then((result) => {
    }, (error) => {
      console.error(error);
    });
  }


  makeFileRequest1(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var newDate = Date.now();
      this.FileNameOrignalDisplay.push(this.itemvalue);
      formData.append("file", this.itemvalue, this.FileName);
      this.FileChangedName.push(this.FileName);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  dismiss() {
    this.editfileurl = null;
  }

  /* Function to open IFrame */



  // openInNewTab(url, name) {
  //   window.open(environment.goEvaFileUrl + url);
  // }

  openInNewTab(url, name) {
    console.log(this.editfileurl,this.editfileurl);
    this.title = name;     
    if(this.editfileurl!=null){
      $('#complinaceDialog').modal('toggle');
      this.editfileurl = null;      
    }
    this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(environment.goEvaFileUrl+url);
   
  }
  refreshComponent() {
    this.alert.success("List has been updated!");
    this.getCompliancelist(); 

  }

}
